module.exports = __webpack_public_path__ + "static/media/DS_Membership_Pic2.5666f12c.webp";